// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-checkbox {
  --size: 22px;
  --background-checked: #007bff;
}

ion-checkbox::part(container) {
  border-radius: 6px;
  border: 2px solid #007bff;
  --checkmark-color: white;
}

ion-col.ion-text-center.md.hydrated {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/abonnement-form/abonnement-form.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,6BAAA;AACJ;;AAEE;EACE,kBAAA;EACA,yBAAA;EACA,wBAAA;AACJ;;AAEE;EACE,aAAA;EAEA,uBAAA;EACA,mBAAA;AAAJ","sourcesContent":["ion-checkbox {\r\n    --size: 22px;\r\n    --background-checked: #007bff;\r\n  }\r\n  \r\n  ion-checkbox::part(container) {\r\n    border-radius: 6px;\r\n    border: 2px solid #007bff;\r\n    --checkmark-color: white;\r\n  }\r\n\r\n  ion-col.ion-text-center.md.hydrated {\r\n    display: flex\r\n;\r\n    justify-content: center;\r\n    align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
